import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { DigitalTeam } from "@/components/DigitalTeam";
import { FAQ } from "@/components/FAQ";
import { CTAFooter } from "@/components/CTAFooter";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { PageContainer } from "@/components/layout/PageContainer";
import { ComponentErrorBoundary } from "@/components/error-boundary/ComponentErrorBoundary";
import { LoadingState } from "@/components/layout/LoadingState";


const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://scienzahealth.com/#webpage",
  "url": "https://scienzahealth.com",
  "name": "Scienza Health - Digital Human® AI Platform",
  "description": "Solve healthcare's capacity crisis with Digital Human® AI. Automated patient intakes, follow-ups, and cognitive screens in under 60 seconds.",
  "publisher": {
    "@type": "Organization",
    "name": "Scienza Health",
    "logo": {
      "@type": "ImageObject",
      "url": "https://scienzahealth.com/mcai_logo_green.svg"
    }
  },
  "mainEntity": {
    "@type": "SoftwareApplication",
    "name": "Scienza Health Platform",
    "applicationCategory": "HealthcareApplication",
    "operatingSystem": "Web-based",
    "offers": {
      "@type": "Offer",
      "category": "Cognitive Health Monitoring"
    },
    "featureList": [
      "Automated patient intakes",
      "Digital Human® AI interaction",
      "Clinical follow-up automation",
      "Cognitive screening in under 60 seconds"
    ]
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://scienzahealth.com"
      }
    ]
  }
};

const Index = () => {
  console.log("Starting Index page render");
  
  return (
    <>
      <Helmet>
        <title>Scienza Health - Digital Human® AI Platform | Too Many Patients, Too Little Time</title>
        <meta 
          name="description" 
          content="Solve healthcare's capacity crisis with Digital Human® AI. Automated patient intakes, follow-ups, and cognitive screens in under 60 seconds. Focus on care, not clicks." 
        />
        <link rel="canonical" href="https://scienzahealth.com" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <PageContainer>
        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="Hero">
            <Hero />
          </ComponentErrorBoundary>
        </Suspense>

        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="Features">
            <Features />
          </ComponentErrorBoundary>
        </Suspense>

        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="DigitalTeam">
            <DigitalTeam />
          </ComponentErrorBoundary>
        </Suspense>

        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="FAQ">
            <FAQ />
          </ComponentErrorBoundary>
        </Suspense>

        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="CTAFooter">
            <CTAFooter />
          </ComponentErrorBoundary>
        </Suspense>


        <Suspense fallback={<LoadingState />}>
          <ComponentErrorBoundary componentName="Contact">
            <Contact />
          </ComponentErrorBoundary>
        </Suspense>
      </PageContainer>
      
      <Footer />
    </>
  );
};

export default Index;